import React from "react";

const Headadmission = () => {
  return (
    <div
      style={{
        backgroundImage: `url(/meetImage.jpg)`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
      className="relative lg:w-full lg:h-screen w-full h-[222px] flex justify-start items-center px-[25px]"
    >
      <div className="absolute bottom-5 font-['Roboto'] bg-[#1A233880] rounded-2xl p-4">
        <p className=" lg:text-6xl text-lg  font-['Roboto'] font-extrabold text-[#FFA901]">
          Start the Admission Process
        </p>
      </div>
    </div>
  );
};

export default Headadmission;
